import { RewardSort } from 'entity/reward/rewardTypes';

const useSortList = (): { title: string; value: RewardSort }[] => {
  return [
    {
      title: 'Featured',
      value: 'featured',
    },
    {
      title: 'Latest',
      value: 'latest',
    },
    {
      title: 'Increasing Credits',
      value: 'creditAsc',
    },
    {
      title: 'Decreasing Credits',
      value: 'creditDesc',
    },
  ];
};

export default useSortList;
